var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-input',{attrs:{"placeholder":"请输入标题"},on:{"input":_vm.sendTitle},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }